import {Controller} from "stimulus";
import MicroModal from 'micromodal';
import cart from "util/cart.js";
import newCart from "util/new_cart.js";
import order from "util/order.js";
import {useDispatch} from "stimulus-use";
import {getCookie} from "../../init/cookie";

export default class extends Controller {
    static targets = ["total", "subtotal", "checkoutBtn", "cartItem", "countProperties", "labelSubtotal"];

    connect() {
        useDispatch(this);
        MicroModal.init({
            disableScroll: true,
            onShow: modal => window.dispatchEvent(new CustomEvent(`gallery-modal-opened-${modal.id}`))
        });

        this.updateCartItemsCount();
        this.updateLabelSubtotal();
    }

    updateCartItemsCount() {
        newCart.size.then(size => {
            if (size) {
                this.countPropertiesTarget.textContent = size > 1 ? `${size} Accommodations` : `${size} Accommodation`
            }
        })
    }

    handleCartUpdated() {
        this.updateCartItemsCount();
        this.calculateSubtotal();
        this.updateLabelSubtotal();
    }

    handleCartItemQuoteUpdated(event) {
        // Each cart item reports its (discounted) total before taxes once its
        // quote loads, so recompute the footer from those values.
        this.calculateSubtotal();
    }

    calculateSubtotal() {
        if (!this.hasSubtotalTarget) return;
        // Sum the per-item "total before taxes" values, which already reflect
        // any applied coupon (the server total does not, since the coupon is
        // display-only and never persisted on the order).
        const total = this.totalTargets.reduce((sum, input) => sum + (parseFloat(input.value) || 0), 0);
        this.subtotalTarget.textContent = `$${total.toLocaleString('en-US')}`;
    }

    enableCheckoutButton() {
        this.checkoutBtnTarget.removeAttribute("disabled");
    }

    disableCheckoutButton() {
        this.checkoutBtnTarget.setAttribute("disabled", true);
    }

    updateLabelSubtotal() {
        const suffix = '&nbsp;';
        const label = 'Total before taxes:';
        this.labelSubtotalTarget.innerHTML = `${label}${suffix}`;
    }

    handleItemQuoteResponse(item, response) {
        if (response.status === "error") {
            cart.remove(item.params.type, item.params.unit_id);
            this.dispatch("unavailableItems", {
                unit_type: item.params.type,
                unit_id: item.params.unit_id
            })
        }
    }

    async checkAvailableItems() {
        return;
        try {
            const itemsWithQuotes = await cart.itemsWithQuotes();
            itemsWithQuotes.forEach(item => {
                this.handleItemQuoteResponse(item, item.quote);
            })

        } catch (error) {
            console.error('Error checking availability of cart items:', error);
        }
        if (cart.items().length === 0) {
            this.disableCheckoutButton()
        }
    }

    async handleProceedToBooking(e) {
        // check availability when long time do not reload page and click on button
        e.preventDefault();
        const buttonForm = e.currentTarget;
        newCart.checkout()
    }

    async oldhandleProceedToBooking(e) {
        // check availability when long time do not reload page and click on button
        e.preventDefault();
        const buttonForm = e.currentTarget;

        try {
            const itemsWithQuotes = await cart.itemsWithQuotes();
            itemsWithQuotes.forEach(item => {
                this.handleItemQuoteResponse(item, item.quote);
            })

        } catch (error) {
            console.error('Error checking availability of cart items:', error);
        }

        if (cart.items().length > 0) {
            const cartItems = cart.items();
            const promoCode = getCookie("promo_code");
            if (promoCode) {
                cartItems.forEach(cartItem => {
                    cartItem.promo_code = promoCode;
                });

            }
            order.create(cartItems);
            buttonForm.submit();
        } else {
            this.disableCheckoutButton()
        }
    }

    _dispatchDataLayer() {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(window.cartLayer);
    }
}
